// Script-style hierarchical cue numbers.
//
// Top-level items (standalone cues AND group cues) get a running whole number
// (1, 2, 3…); a group's children get a decimal under their parent (2.1, 2.2…).
// An orphan child (parent not present) is numbered as a top-level item so it
// never renders as "?.n". Computed over the full cue list so numbers stay
// stable when groups collapse.
//
// Returns Map<cueId, string>.
export function computeCueNumbers(cues) {
  const sorted = [...cues].sort((a, b) => a.order - b.order);
  const numbers = new Map();
  const topNumberOf = new Map(); // top-level cue id → its number string
  const childCount = new Map();  // parent id → running child counter
  let top = 0;
  for (const c of sorted) {
    if (!c.parent_id || !topNumberOf.has(c.parent_id)) {
      top += 1;
      const n = String(top);
      numbers.set(c.id, n);
      topNumberOf.set(c.id, n);
    } else {
      const next = (childCount.get(c.parent_id) || 0) + 1;
      childCount.set(c.parent_id, next);
      numbers.set(c.id, `${topNumberOf.get(c.parent_id)}.${next}`);
    }
  }
  return numbers;
}
